import { z } from 'zod';

import {
  emailString,
  optionalString,
  requiredString,
} from '@/shared/utils/validation';

export const createUpdateUserInputSchema = (isGroupRequired = false) =>
  z.object({
    firstName: requiredString(),
    lastName: requiredString(),
    email: emailString(),
    companyName: optionalString(),
    groupId: isGroupRequired ? requiredString() : optionalString(),
  });
